import React from 'react';
import { Body, Box, Icon } from '@hover/blueprint';
import { iX } from '@hover/icons';
import styled from '@emotion/styled';
import AccordionContent from './AccordionContent';

interface Props {
  isActive: boolean;
  listItems: string[];
  body: string;
  header: string;
  onClick: () => void;
}

export const StyledIcon = styled(Icon)`
  transform: rotateZ(${props => (props.isActive ? 0 : '45deg')});
  transition: all 0.2s ease;
`;

const CustomAccordion: React.FC<Props> = ({
  isActive,
  listItems,
  body,
  header,
  onClick,
}) => (
  <Box flexDir="column" mt={isActive ? '42px' : '26px'}>
    <Box cursor="pointer" flexDir="row" onClick={onClick}>
      <StyledIcon mr={400} icon={iX} isActive={isActive} size="default" />
      <Body mb={!isActive ? '28px' : 200} size={600} isSemiBold as="h3">
        {header}
      </Body>
    </Box>
    <Box
      transition="all 0.3s linear"
      ml={700}
      maxH={isActive ? '1000px' : 0}
      opacity={isActive ? 1 : 0}
    >
      <AccordionContent listItems={listItems} body={body} />
    </Box>
  </Box>
);

export default CustomAccordion;
